<template>
  <v-container>
    <v-row justify="space-between" dense>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-card class="elevation-2">
            <title-bar></title-bar>
            <v-card class="mb-3">
              <v-card-text>
                <h3>EMPLOYMENT NOTICES</h3>
                  <v-card class="mb-3">
                    <v-card-text>
                      I hereby certify that I have not knowingly withheld
                      any information that might adversely affect my chances
                      for employment and that the answers given by me are
                      true and correct to the best of my knowledge. I
                      further certify that I, the undersigned applicant,
                      have personally completed (or used a preparer to
                      complete) this application. I understand that any
                      omission or misstatement of material fact on this
                      application or on any document used to secure
                      employment shall be grounds rejection of this
                      application or for immediate discharge if I am
                      employed, regardless of the time elapsed before
                      discovery.
                    </v-card-text>
                  </v-card>
                  <v-card class="mb-3">
                    <v-card-text>
                      I understand that nothing contained in the
                      application, or conveyed during any interview which
                      may be granted or during my employment, if hired, is
                      intended to create an employment contract between me
                      and the Company. In addition, I understand and agree
                      that if I am employed, my employment is for no
                      definite or determinable period and may be terminated
                      at any time, with or without prior notice, at the
                      option of either myself or the Company, and that no
                      promises or representations contrary to the foregoing
                      are binding on the Company unless made in writing and
                      signed by me and the Company’s designated
                      representative.
                    </v-card-text>
                  </v-card>
                  <v-card class="mb-3">
                    <v-card-text>
                      I understand that in compliance with federal law, if
                      hired, I will be required to verify identity and
                      eligibility to work in the United States and to
                      complete the required I-9 form.
                    </v-card-text>
                  </v-card>
              </v-card-text>
            </v-card>
            <footer-bar></footer-bar>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import TitleBar from "../components/TitleBar";
import FooterBar from "../components/Footer";

export default {
  components: { TitleBar, FooterBar }
};
</script>
